import React from "react";
import Alert from "@mui/material/Alert";

import useClassBooking from "./useClassBooking";
import useClassScrollSpy from "./useClassScrollSpy";
import ClassesMobileLayout from "./ClassesMobileLayout";
import ClassesDesktopLayout from "./ClassesDesktopLayout";

function ClassesView() {
  const cls = useClassBooking();
  const scrollSpy = useClassScrollSpy({
    dayViewActive: cls.dayViewActive,
    nonEmptyDays: cls.nonEmptyDays,
    classesByDate: cls.classesByDate,
    pendingDay: cls.pendingDay,
    clearPendingDay: cls.clearPendingDay
  });

  if (cls.classServices.length === 0 && !cls.loading) {
    return <Alert severity="info">No group classes are currently available.</Alert>;
  }

  return cls.isMobile ? <ClassesMobileLayout cls={cls} scrollSpy={scrollSpy} /> : <ClassesDesktopLayout cls={cls} scrollSpy={scrollSpy} />;
}

export default ClassesView;
